import { useSyncExternalStore } from "react";

type Listener = () => void;

let isRestricted = false;
const listeners = new Set<Listener>();

const emit = () => {
  listeners.forEach((l) => l());
};

export const supabaseHealthStore = {
  markRestricted() {
    if (!isRestricted) {
      isRestricted = true;
      emit();
    }
  },
  markHealthy() {
    if (isRestricted) {
      isRestricted = false;
      emit();
    }
  },
  getSnapshot() {
    return isRestricted;
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

const getServerSnapshot = () => false;

export const useSupabaseHealth = () => {
  const restricted = useSyncExternalStore(
    supabaseHealthStore.subscribe,
    supabaseHealthStore.getSnapshot,
    getServerSnapshot
  );
  return { isRestricted: restricted };
};
